import React from 'react'

const Temp = () => {
    return (
        <div className='container'>
            <h1>Template of C++</h1>  
            <br />
            <p>This is the basic structure of C++ you will write this structure in every program </p>
            <div className='containers'>
            <code className='library'>#include</code> &lt; iostream &gt; <br />
            <code className='keywords'>Using namespace std;</code> <br />
          <code className='keywords'>  int</code> main() &#123;  <br />
          <div className='comment'>//This is the body part where you write your code</div>
          <code className='keywords'>cout </code> &lt; &lt; <code className='plain'>"Hello World!"</code> &gt;&gt;endl; <br />
          <code className='library'> return </code> 0; <br />
&#125;  <br /></div>
<ul>
    <li><p><strong>#include </strong> is a specific preprocessor command that effectively
     copies and pastes the entire text of the file, specified between the angle brackets,
      into the source code.</p></li>
    <li><p>The file<strong>&lt;iostream&gt;</strong>which is a standard file that should come with the C++ compiler, is short for input-output streams. This command contains code for displaying and getting an input from the user.</p></li>
    <li><p><strong>namespace </strong> is a prefix that is applied to all the names in a certain set.
     <strong>iostream</strong>  file defines two names used in this program - <strong>cout and endl</strong> .</p></li>
     <li><p>This code is saying: Use the cout and endl tools from the std toolbox.</p></li>

</ul>
<p><strong>Main function section</strong></p> <br /> <br />
<ul>
    <li>The starting point of all C++ programs is the <strong>main</strong> function.</li>
    <li>This function is called by the operating system when your program is executed by the computer.</li>
    <li>&#123; signifies the start of a block of code, ​and &#125; signifies the end.</li>
</ul>
<p><strong>Function body section</strong></p>
<ul>
    <li>The name <strong>cout</strong>  is short for character output and displays whatever is between the &lt;&lt; brackets.</li>
    <li>Symbols such as &lt;&lt; can also behave like functions and are used with the keyword <strong> cout</strong>.
    <li>The <strong> return</strong> keyword tells the program to return a value to the function <strong>int main</strong> </li>
    <li>After the return statement, execution control returns to the operating system component that launched this program.</li>
    <li>Execution of the code terminates here.</li>
</li>

</ul>
        </div>
    )
}

export default Temp
